import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const ListingSection = union([
    literal("prep"),
    literal("progression")
]);